"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5725],{

/***/ 95894:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ safeParseEventValue; }
/* harmony export */ });
function safeParseEventValue(e) {
    // safe attempt to parse form value
    if (!e) {
        return e;
    }
    if (!e.target) {
        return e;
    }
    var target = e.target;
    if (target.getAttribute) {
        return target.getAttribute("type") === "checkbox" || target.getAttribute("type") === "radio" ? target.getAttribute("checked") : typeof target.value === "string" ? target.value : target.getAttribute("data-value") || target.getAttribute("value");
    }
    if (target && target.textContent) {
        return e.target.textContent;
    }
    return target ? target.value : e;
}


/***/ }),

/***/ 81194:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "BB": function() { return /* binding */ openConfirm; }
});

// UNUSED EXPORTS: Modal, ModalBody, ModalFooter, ModalHeader, openAlert, openModal

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/preact/compat/jsx-runtime.mjs + 1 modules
var jsx_runtime = __webpack_require__(97997);
// EXTERNAL MODULE: ./node_modules/preact/compat/dist/compat.module.js + 1 modules
var compat_module = __webpack_require__(11720);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/reactstrap/dist/reactstrap.modern.js
var reactstrap_modern = __webpack_require__(50450);
// EXTERNAL MODULE: ./components/base/forms/Button.tsx
var Button = __webpack_require__(41280);
// EXTERNAL MODULE: ./components/base/forms/Input.tsx + 1 modules
var Input = __webpack_require__(4386);
// EXTERNAL MODULE: ./common/utils/forms/safeEventParseValue.ts
var safeEventParseValue = __webpack_require__(95894);
// EXTERNAL MODULE: ./common/utils/string/GUID.ts
var GUID = __webpack_require__(93654);
;// CONCATENATED MODULE: ./components/base/ModalConfirm.tsx









var Confirm = function(param) {
    var challenge = param.challenge, children = param.children, disabled = param.disabled, disabledYes = param.disabledYes, isDanger = param.isDanger, isOpen = param.isOpen, _noText = param.noText, noText = _noText === void 0 ? "Cancel" : _noText, onNo = param.onNo, onYes = param.onYes, title = param.title, toggle = param.toggle, _yesText = param.yesText, yesText = _yesText === void 0 ? "OK" : _yesText;
    var id = (0,compat_module.useRef)((0,GUID/* GUID */.x)());
    (0,compat_module.useEffect)(function() {
        if (challenge) {
            var ref;
            (ref = document.getElementById(id.current)) === null || ref === void 0 ? void 0 : ref.focus();
        }
    }, [
        challenge
    ]);
    var no = function() {
        return onNo ? onNo(toggle) : toggle === null || toggle === void 0 ? void 0 : toggle();
    };
    var yes = function() {
        return onYes ? onYes(toggle) : toggle === null || toggle === void 0 ? void 0 : toggle();
    };
    var ref = (0,_sliced_to_array/* default */.Z)((0,compat_module.useState)(""), 2), challengeAnswer = ref[0], setChallengeAnswer = ref[1];
    var invalidateChallenge = !!challenge && challenge !== challengeAnswer;
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(reactstrap_modern/* Modal */.u_, {
        unmountOnClose: true,
        isOpen: isOpen,
        toggle: no,
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(reactstrap_modern/* ModalHeader */.xB, {
                toggle: no,
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(reactstrap_modern/* ModalBody */.fe, {
                children: [
                    children,
                    challenge && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Input/* default */.Z, {
                        id: id.current,
                        onKeyPress: function(e) {
                            if (e.key === "Enter" && challengeAnswer === challenge) {
                                yes();
                            }
                        },
                        className: "mt-2",
                        value: challengeAnswer,
                        onChange: function(e) {
                            return setChallengeAnswer((0,safeEventParseValue/* safeParseEventValue */.Q)(e));
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(reactstrap_modern/* ModalFooter */.mz, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Button/* Button */.zx, {
                        style: {
                            width: 90
                        },
                        theme: "secondary",
                        "data-test": "confirm-no",
                        disabled: disabled,
                        onClick: no,
                        children: noText
                    }),
                    isDanger ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Button/* Button */.zx, {
                        style: {
                            width: 90
                        },
                        theme: "danger",
                        "data-test": "confirm-yes",
                        disabled: disabled || disabledYes || invalidateChallenge,
                        iconRight: "fas fa-trash",
                        onClick: yes,
                        children: yesText
                    }) : /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Button/* Button */.zx, {
                        style: {
                            width: 90
                        },
                        "data-test": "confirm-yes",
                        disabled: disabled || disabledYes || invalidateChallenge,
                        onClick: yes,
                        children: yesText
                    }),
                    " "
                ]
            })
        ]
    });
};
/* harmony default export */ var ModalConfirm = (Confirm);

// EXTERNAL MODULE: ./components/base/ModalDefault.tsx
var ModalDefault = __webpack_require__(17977);
;// CONCATENATED MODULE: ./components/base/ModalAlert.tsx



var ModalAlert = function(param) {
    var children = param.children, isOpen = param.isOpen, _okText = param.okText, okText = _okText === void 0 ? "ok" : _okText, onDismiss = param.onDismiss, title = param.title, toggle = param.toggle;
    var onDissmissClick = function() {
        if (onDismiss) {
            onDismiss();
        }
        toggle === null || toggle === void 0 ? void 0 : toggle();
    };
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(reactstrap_modern/* Modal */.u_, {
        unmountOnClose: true,
        isOpen: isOpen,
        toggle: onDissmissClick,
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(reactstrap_modern/* ModalHeader */.xB, {
                toggle: onDissmissClick,
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(reactstrap_modern/* ModalBody */.fe, {
                children: children
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(reactstrap_modern/* ModalFooter */.mz, {
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Button/* Button */.zx, {
                    onClick: onDissmissClick,
                    children: okText
                })
            })
        ]
    });
};
ModalAlert.displayName = "ModalAlert";
/* harmony default export */ var base_ModalAlert = (ModalAlert);

// EXTERNAL MODULE: ./common/store.ts + 3 modules
var store = __webpack_require__(71185);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 14 modules
var es = __webpack_require__(41248);
;// CONCATENATED MODULE: ./components/base/Modal.tsx











var ModalHeader = (/* unused pure expression or super */ null && (_ModalHeader));
var ModalFooter = (/* unused pure expression or super */ null && (_ModalFooter));
var Modal = (/* unused pure expression or super */ null && (_Modal));
var ModalBody = (/* unused pure expression or super */ null && (_ModalBody));
var withModal = function(WrappedComponent) {
    return function(props) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        var ref = (0,compat_module.useState)(true), isOpen = ref[0], setIsOpen = ref[1];
        // eslint-disable-next-line react-hooks/rules-of-hooks
        var toggle = (0,compat_module.useCallback)(function() {
            return setIsOpen(false);
        }, [
            setIsOpen
        ]);
        __webpack_require__.g.closeModal = toggle;
        return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(es/* Provider */.zt, {
            store: (0,store/* getStore */.b)(),
            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(WrappedComponent, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                toggle: toggle
            }, props), {
                isOpen: isOpen
            }))
        });
    };
};
var _Confirm = withModal(ModalConfirm);
var _Alert = withModal(base_ModalAlert);
var _ModalDefault = withModal(ModalDefault/* default */.Z);
var openAlert = __webpack_require__.g.openAlert = function(title, children, onDismiss) {
    document.getElementById("alert") && // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0,compat_module.unmountComponentAtNode)(document.getElementById("alert"));
    (0,compat_module.render)(/*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(_Alert, {
        title: title,
        onDismiss: onDismiss,
        children: children
    }), document.getElementById("alert"));
};
var openConfirm = __webpack_require__.g.openConfirm = function(title, body, onYes) {
    var onNo = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null, yesText = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : undefined, noText = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : undefined;
    document.getElementById("confirm") && // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0,compat_module.unmountComponentAtNode)(document.getElementById("confirm"));
    (0,compat_module.render)(/*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(_Confirm, {
        yesText: yesText,
        noText: noText,
        isOpen: true,
        onNo: onNo,
        onYes: onYes,
        title: title,
        children: body
    }), document.getElementById("confirm"));
};
var openModal = __webpack_require__.g.openModal = function(title, body) {
    document.getElementById("modal") && // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0,compat_module.unmountComponentAtNode)(document.getElementById("modal"));
    (0,compat_module.render)(/*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(_ModalDefault, {
        isOpen: true,
        title: title,
        children: body
    }), document.getElementById("modal"));
};


/***/ }),

/***/ 17977:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10092);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97997);
/* harmony import */ var reactstrap__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50450);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11720);





var ModalDefault = function(param) {
    var children = param.children, className = param.className, isOpen = param.isOpen, modalClassName = param.modalClassName, onBeforeClose = param.onBeforeClose, onDismiss = param.onDismiss, _preventDismiss = param.preventDismiss, preventDismiss = _preventDismiss === void 0 ? false : _preventDismiss, sideModal = param.sideModal, size = param.size, title = param.title, toggle = param.toggle;
    var handleToggle = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
        var shouldClose, err;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (preventDismiss) return [
                        2
                    ];
                    if (!onBeforeClose) return [
                        3,
                        5
                    ];
                    shouldClose = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        onBeforeClose()
                    ];
                case 2:
                    shouldClose = _state.sent();
                    return [
                        3,
                        4
                    ];
                case 3:
                    err = _state.sent();
                    console.error("onBeforeClose threw:", err);
                    shouldClose = false;
                    return [
                        3,
                        4
                    ];
                case 4:
                    if (!shouldClose) return [
                        2
                    ];
                    _state.label = 5;
                case 5:
                    onDismiss();
                    toggle();
                    return [
                        2
                    ];
            }
        });
    }), [
        preventDismiss,
        onBeforeClose,
        onDismiss,
        toggle
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)(reactstrap__WEBPACK_IMPORTED_MODULE_4__/* .Modal */ .u_, {
        isOpen: isOpen,
        size: size,
        unmountOnClose: true,
        backdrop: preventDismiss ? "static" : true,
        keyboard: !preventDismiss,
        modalClassName: sideModal ? "side-modal" : modalClassName,
        toggle: handleToggle,
        children: [
            !!title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(reactstrap__WEBPACK_IMPORTED_MODULE_4__/* .ModalHeader */ .xB, {
                toggle: !preventDismiss ? handleToggle : undefined,
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(reactstrap__WEBPACK_IMPORTED_MODULE_4__/* .ModalBody */ .fe, {
                className: className,
                children: children
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ModalDefault);


/***/ }),

/***/ 22299:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97997);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11720);
/* harmony import */ var react_tooltip__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24762);
/* harmony import */ var common_utils_string_GUID__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93654);




var Tooltip = function(param) {
    var children = param.children, content = param.content, place = param.place, showIcon = param.showIcon;
    var id = (0,common_utils_string_GUID__WEBPACK_IMPORTED_MODULE_3__/* .GUID */ .x)();
    if (!content) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .Fragment */ .HY, {
            children: children
        });
    }
    var icon = showIcon && children ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("span", {
        className: "ms-1 fa fa-info-circle",
        "data-for": id,
        "data-tip": true
    }) : null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .Fragment */ .HY, {
        children: [
            children && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("span", {
                "data-for": id,
                "data-tip": true,
                children: [
                    children,
                    icon
                ]
            }),
            !children && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("span", {
                className: "fa fa-info-circle",
                "data-for": id,
                "data-tip": true
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(react_tooltip__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                html: true,
                className: "rounded",
                id: id,
                place: place || "top",
                type: "dark",
                effect: "solid",
                children: typeof content === "string" ? content : content
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Tooltip);


/***/ }),

/***/ 41280:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "zx": function() { return /* binding */ Button; }
/* harmony export */ });
/* unused harmony exports themeClassNames, sizeClassNames */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97997);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11720);
/* harmony import */ var react_hotkeys_hook__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46977);








var themeClassNames = {
    danger: "btn btn-danger",
    outlineDanger: "btn btn-outline-danger",
    outlinePrimary: "btn btn-outline-primary",
    primary: "btn-primary",
    secondary: "btn-secondary",
    tertiary: "btn-tertiary",
    text: "btn-link fw-semibold"
};
var sizeClassNames = {
    default: "",
    "extra-small": "btn-xs",
    large: "btn-lg",
    small: "btn-sm"
};
var Button = function(_param) {
    var children = _param.children, className = _param.className, hideShortcut = _param.hideShortcut, icon = _param.icon, iconLeft = _param.iconLeft, iconRight = _param.iconRight, onClick = _param.onClick, shortcut = _param.shortcut, shortcutLeft = _param.shortcutLeft, _size = _param.size, size = _size === void 0 ? "default" : _size, _theme = _param.theme, theme = _theme === void 0 ? "primary" : _theme, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "children",
        "className",
        "hideShortcut",
        "icon",
        "iconLeft",
        "iconRight",
        "onClick",
        "shortcut",
        "shortcutLeft",
        "size",
        "theme"
    ]);
    var buttonRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    var handleClick = function(e) {
        if (!rest.disabled) {
            var ref;
            (ref = buttonRef.current) === null || ref === void 0 ? void 0 : ref.blur();
            onClick === null || onClick === void 0 ? void 0 : onClick(e);
        }
    };
    (0,react_hotkeys_hook__WEBPACK_IMPORTED_MODULE_3__/* .useHotkeys */ .y1)(shortcut || "", handleClick, [
        onClick
    ]);
    var shortcutEl = shortcut && !hideShortcut && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("i", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("key__button", {
            "me-2": !!shortcutLeft
        }),
        children: shortcut === "Enter" ? "⏎" : shortcut === "ArrowLeft" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("span", {
            className: "fa fa-arrow-left"
        }) : shortcut === "ArrowRight" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("span", {
            className: "fa fa-arrow-right"
        }) : shortcut
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("button", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        type: "button",
        ref: buttonRef
    }, rest), {
        onClick: handleClick,
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("btn", {
            "btn-icon": !!icon,
            "flex-row lh-1 align-items-center": !!shortcut
        }, className, themeClassNames[theme], sizeClassNames[size]),
        children: [
            iconLeft && typeof iconLeft === "string" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("i", {
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("icon icon--left", "me-2", iconLeft)
            }) : iconLeft,
            !!shortcutLeft && shortcutEl,
            children,
            iconRight && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("i", {
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("icon icon--right", "ms-2", iconRight)
            }),
            !shortcutLeft && shortcutEl
        ]
    }));
};
Button.displayName = "Button";
/* harmony default export */ __webpack_exports__["ZP"] = (Button);


/***/ }),

/***/ 4386:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ forms_Input; }
});

// UNUSED EXPORTS: sizeClassNames

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/preact/compat/jsx-runtime.mjs + 1 modules
var jsx_runtime = __webpack_require__(97997);
// EXTERNAL MODULE: ./node_modules/preact/compat/dist/compat.module.js + 1 modules
var compat_module = __webpack_require__(11720);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./common/utils/forms/keys.ts
var KEY_Y = 89;
var KEY_Z = 90;
var keys = {
    isBackspace: function isBackspace(e) {
        // returns bool
        if (!e) return false;
        var code = e.keyCode ? e.keyCode : e.which;
        return code === 8 && !e.shiftKey && !e.ctrlKey;
    },
    isDown: function isDown(e) {
        // returns bool
        if (!e) return false;
        var code = e.keyCode ? e.keyCode : e.which;
        return code === 40 && !e.shiftKey && !e.ctrlKey;
    },
    isEnter: function isEnter(e) {
        // returns bool
        if (!e) return false;
        var code = e.keyCode ? e.keyCode : e.which;
        return code === 13 && !e.shiftKey && !e.ctrlKey;
    },
    isEscape: function isEscape(e) {
        if (!e) return false;
        var code = e.keyCode ? e.keyCode : e.which;
        return code === 27 && !e.shiftKey && !e.ctrlKey;
    },
    isLeft: function isLeft(e) {
        // returns bool
        if (!e) return false;
        var code = e.keyCode ? e.keyCode : e.which;
        return code === 37 && !e.shiftKey && !e.ctrlKey;
    },
    isRedo: function isRedo(e) {
        if (!e) return false;
        return (e.ctrlKey || e.metaKey) && e.keyCode === (e.shiftKey ? KEY_Z : KEY_Y);
    },
    isRight: function isRight(e) {
        // returns bool
        if (!e) return false;
        var code = e.keyCode ? e.keyCode : e.which;
        return code === 39 && !e.shiftKey && !e.ctrlKey;
    },
    isTab: function isTab(e) {
        // returns bool
        if (!e) return false;
        var code = e.keyCode ? e.keyCode : e.which;
        return code === 9 && !e.shiftKey && !e.ctrlKey;
    },
    isUndo: function isUndo(e) {
        if (!e) return false;
        return (e.ctrlKey || e.metaKey) && e.keyCode === (e.shiftKey ? KEY_Y : KEY_Z);
    },
    isUp: function isUp(e) {
        // returns bool
        if (!e) return false;
        var code = e.keyCode ? e.keyCode : e.which;
        return code === 38 && !e.shiftKey && !e.ctrlKey;
    }
};

;// CONCATENATED MODULE: ./components/base/forms/Input.tsx







var sizeClassNames = {
    default: "",
    large: "form-control-lg",
    small: "form-control-sm"
};
var Input = function(_param) {
    var children = _param.children, className = _param.className, disabled = _param.disabled, iconLeft = _param.iconLeft, iconRight = _param.iconRight, id = _param.id, inputClassName = _param.inputClassName, inputRef = _param.inputRef, _isValid = _param.isValid, isValid = _isValid === void 0 ? true : _isValid, name = _param.name, onBlur = _param.onBlur, onFocus = _param.onFocus, onIconLeftClick = _param.onIconLeftClick, onIconRightClick = _param.onIconRightClick, onKeyDown = _param.onKeyDown, _placeholder = _param.placeholder, placeholder = _placeholder === void 0 ? " " : _placeholder, _shouldValidate = _param.shouldValidate, _size = _param.size, size = _size === void 0 ? "default" : _size, textarea = _param.textarea, touched = _param.touched, type = _param.type, value = _param.value, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "className",
        "disabled",
        "iconLeft",
        "iconRight",
        "id",
        "inputClassName",
        "inputRef",
        "isValid",
        "name",
        "onBlur",
        "onFocus",
        "onIconLeftClick",
        "onIconRightClick",
        "onKeyDown",
        "placeholder",
        "shouldValidate",
        "size",
        "textarea",
        "touched",
        "type",
        "value"
    ]);
    var ref = (0,compat_module.useState)(false), shouldValidate = ref[0], setShouldValidate = ref[1];
    (0,compat_module.useEffect)(function() {
        if (_shouldValidate) {
            setShouldValidate(true);
        }
    }, [
        _shouldValidate
    ]);
    var ref1 = (0,compat_module.useState)(false), isFocused = ref1[0], setIsFocused = ref1[1];
    var ref2 = inputRef || (0,compat_module.useRef)();
    var focusHandler = function(e) {
        setIsFocused(true);
        onFocus && onFocus(e);
    };
    var onKeyDownHandler = function(e) {
        if (keys.isEscape(e)) {
            var ref;
            (ref = ref2.current) === null || ref === void 0 ? void 0 : ref.blur();
        }
        onKeyDown && onKeyDown(e);
    };
    var blurHandler = function(e) {
        setShouldValidate(true);
        setIsFocused(false);
        onBlur && onBlur(e);
    };
    var togglePasswordVisibility = function() {
        setShowPassword(!showPassword);
    };
    var classNameHandler = classnames_default()("position-relative input-container", {
        focused: isFocused,
        "input-container--with-left-icon": !!iconLeft,
        "input-container--with-right-icon": !!iconRight,
        invalid: (shouldValidate || touched) && !isValid
    }, className);
    var combinedInputClassName = classnames_default()({
        error: !(shouldValidate || touched) && !isValid,
        "form-control": true
    }, // @ts-ignore
    sizeClassNames[size], inputClassName);
    var ref3 = (0,compat_module.useState)(false), showPassword = ref3[0], setShowPassword = ref3[1];
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
        className: classNameHandler,
        children: [
            textarea ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("textarea", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                name: name,
                placeholder: placeholder
            }, rest), {
                id: id,
                // @ts-ignore
                ref: ref2,
                onFocus: focusHandler,
                onKeyDown: onKeyDownHandler,
                onBlur: blurHandler,
                value: value,
                className: combinedInputClassName
            })) : /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(jsx_runtime/* Fragment */.HY, {
                children: [
                    !!iconLeft && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                        onClick: onIconLeftClick,
                        className: classnames_default()("input-icon icon-left", {
                            "icon-disabled": disabled,
                            "pe-none": !onIconLeftClick
                        }),
                        children: iconLeft
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("input", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        disabled: disabled,
                        name: name,
                        type: type === "password" && showPassword ? "" : type
                    }, rest), {
                        id: id,
                        // @ts-ignore
                        ref: ref2,
                        onFocus: focusHandler,
                        onKeyDown: onKeyDownHandler,
                        onBlur: blurHandler,
                        value: value,
                        placeholder: placeholder,
                        className: combinedInputClassName
                    })),
                    iconRight ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                        onClick: onIconRightClick,
                        className: classnames_default()("input-icon icon-right", {
                            "icon-disabled": disabled,
                            "pe-none": !onIconRightClick
                        }),
                        children: iconRight
                    }) : type === "password" && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("i", {
                        onClick: togglePasswordVisibility,
                        className: classnames_default()("input-icon icon-right", {
                            "fas fa-eye": !showPassword,
                            "fas fa-eye-slash": showPassword,
                            "icon-disabled": disabled
                        })
                    })
                ]
            }),
            children && children
        ]
    });
};
Input.displayName = "Input";
/* harmony default export */ var forms_Input = (Input);


/***/ })

}]);